import PenaltyShootout from "./PenaltyShootout";
export default PenaltyShootout;
